import React, { ChangeEvent } from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Button, Checkbox, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import InputTextField from "./TextField";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '400px',
            display: 'inline-grid',
            alignSelf: 'center'
        },
        label: {
            fontSize: '20px',
            color: '#D3D3D3',
        },
        labelSelected: {
            fontSize: '16px',
            color: '#D3D3D3',
            textDecoration: 'underline',
            textDecorationColor: '#DA2232',
            textDecorationThickness: '2px',
            textUnderlineOffset: '8px',
        },
        link: {
            fontSize: '15px',
            fontWeight: 'bold',
            color: '#000000',
            paddingBottom: '16px',
            textDecoration: 'underline'
        },
        checkbox: {
            color: '#000000'
        },
        button: {
            width: '250px',
            backgroundColor: '#da2232',
            color: '#ffffff',
            borderRadius: '0px',
            '&:hover': {
                backgroundColor: '#da2232',
                color: '#ffffff',
            },
        },
        title: {
            marginBottom: 2,
            height: '24px',
            fontSize: '16px',
            weight: 800,
            fontWeight: 'bold',
            color: '#333333',
        },
        titleBig: {
            marginBottom: 2,
            height: '31px',
            fontSize: '22px',
            fontWeight: 600,
            lineHeight: '31px',
            color: '#333333',
            textAlign: 'left'
        },
    })
);

interface IProps {
    formState: any,
    formErrors: any,
    handleFormChange: (e: ChangeEvent<HTMLInputElement>) => any,
}

const CartAnonymous: React.FC<IProps> = ({
    formState,
    formErrors,
    handleFormChange,
}) => {

    const classes = useStyles();
    const intl = useIntl();

    return (
        <>
            <Grid item md={12} >
                <Typography className={classes.titleBig}>
                    <FormattedMessage id="public.buyer" />
                </Typography>
            </Grid>
            <Grid item md={12} >
                <Typography className={classes.title}>
                    <FormattedMessage id="payment.buyer" />
                </Typography>
            </Grid>
            <Grid item md={12} >
                <RadioGroup row
                    name="clientType"
                    onChange={handleFormChange}
                    value={formState.clientType}
                >
                    <FormControlLabel value="business" id='business' control={<Radio />} label="Juridiska persona" />
                    <FormControlLabel value="individual" id="individual" control={<Radio />} label="Fiziska persona" />
                </RadioGroup>
            </Grid>
            {formState.clientType === 'business' ? (
                <Grid item md={12} >
                    <Grid
                        container
                        spacing={3}
                        direction="row">
                        <Grid item xs={12} md={6}>
                            <InputTextField name="companyName" title={intl.formatMessage({ id: 'register.companyName' })} value={formState?.companyName} error={formErrors?.companyName} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputTextField name="companyRegistrationNumber" title={intl.formatMessage({ id: 'register.companyRegistrationNumber' })} value={formState?.companyRegistrationNumber} error={formErrors?.companyRegistrationNumber} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputTextField name="phone" title={intl.formatMessage({ id: 'register.phone' })} value={formState?.phone} error={formErrors?.phone} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputTextField name="email" title={intl.formatMessage({ id: 'register.email' })} value={formState?.email} error={formErrors?.email} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputTextField name="additionalInformation" title="Papildus informacija" value={formState?.additionalInformation} error={formErrors?.additionalInformation} enabled={true} formChange={handleFormChange} />
                        </Grid>
                    </Grid>
                </Grid>
            ) : (null)}
            {formState.clientType === 'individual' ? (
                <Grid item md={12} >
                    <Grid
                        container
                        spacing={3}
                        direction="row">
                        <Grid item xs={12} md={6}>
                            <InputTextField name="personName" title={intl.formatMessage({ id: 'register.name' })} value={formState?.personName} error={formErrors?.personName} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputTextField name="personSurname" title={intl.formatMessage({ id: 'register.surname' })} value={formState?.personSurname} error={formErrors?.personSurname} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputTextField name="phone" title={intl.formatMessage({ id: 'register.phone' })} value={formState?.phone} error={formErrors?.phone} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputTextField name="email" title={intl.formatMessage({ id: 'register.email' })} value={formState?.email} error={formErrors?.email} enabled={true} formChange={handleFormChange} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputTextField name="additionalInformation" title="Papildus informacija" value={formState?.additionalInformation} error={formErrors?.additionalInformation} enabled={true} formChange={handleFormChange} />
                        </Grid>
                    </Grid>
                </Grid>
            ) : (null)}
        </>

    )
};

export default (CartAnonymous);
